module.exports = __webpack_public_path__ + "static/assets/a440a4fa4ea144673ea72f8883a05dea.svg";